<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form">
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="form.type" clearable placeholder="类型" :disabled="form.id>0">
                        <el-option
                            v-for="item in lessonTypes"
                            :key="item.optionValue"
                            :label="item.optionText"
                            :value="item.optionValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="计划分值" style="color:red;">
                    {{ planTotalScore }}
                </el-form-item>
                <el-form-item label="题库分值" style="color:red;">
                    {{ questionBankTotalScore }}
                </el-form-item>
            </el-form>
            <div>
                <el-button type="success" @click="generateQuestion()">生成题库</el-button>
                <el-button type="info" @click="addByPlatform()">从总部导入题库</el-button>
                <el-button type="primary" @click="addChoose()">选择题目</el-button>
                <el-button type="primary" @click="add()">新增题目</el-button>
                <el-button type="primary" @click="editScore()">编辑分数</el-button>
                <el-button type="danger" @click="emptyQuestion()">清空</el-button>
            </div>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="180"
                    prop="questionFormHtml"
                    label="题目">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="statusName"
                    label="类型">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="answer"
                    label="答案">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="score"
                    label="题目分数">
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="180"
                >
                    <template slot-scope="scope">

                        <el-link type="primary" @click="edit(scope.row)"
                                 :underline="false"><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                        <el-popconfirm @onConfirm="deleteQuestion(scope.row)"
                                       title="确认删除该题目吗？"
                        >
                            <el-link type="danger" slot="reference"
                                     :underline="false"><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <AddDraw v-if="showAdd" @submit="loadData"
                 @close="showAdd=false" :item="editItem"></AddDraw>
        <EditDrawer v-if="showEdit" @submit="loadData" :item="editItem"
                    @close="showEdit=false"></EditDrawer>
        <ChooseQuestionDrawer :item="chooseItem" v-if="showChoose" @close="showChoose = false"
                              @submit="loadData"></ChooseQuestionDrawer>
        <ChooseExamPlatformDrawer :item="addExamItem" v-if="showChooseExam" @close="showChooseExam = false"
                                  @submit="loadData"></ChooseExamPlatformDrawer>
        <GenerateQuestionDrawer :item="addGenerateQuestion" v-if="showGenerateQuestion"
                                @close="showGenerateQuestion = false" @submit="loadData"></GenerateQuestionDrawer>
    </div>
</template>

<style scoped>

</style>

<script>
import AddDraw from './add';
import {mapMutations} from 'vuex';
import EditDrawer from './edit';
import ChooseQuestionDrawer from "./ChooseQuestionDrawer";
import ChooseExamPlatformDrawer from "./ChooseExamPlatformDrawer";
import GenerateQuestionDrawer from "./GenerateQuestionDrawer";

export default {
    components: {
        AddDraw,
        EditDrawer,
        ChooseQuestionDrawer,
        ChooseExamPlatformDrawer,
        GenerateQuestionDrawer,
    },
    props: [
        "attr"
    ],
    data() {
        return {
            form: {
                keywords: "",
                enable: true,
                type: '',
                examId: (this.attr && this.attr.exam) ? this.attr.exam.id : null,
            },
            showAdd: false,
            showEdit: false,
            showChoose: false,
            showChooseExam: false,
            showGenerateQuestion: false,
            exam: this.attr && this.attr.exam,
            pager: {
                pageSize: 12,
                dataTotal: 0,
                currentPage: 1
            },
            tableData: [],
            lessonTypes: [],
            questionBankTotalScore: 0,
            planTotalScore: 0,
        }
    },
    watch: {
        "form": {
            handler: function (newValue) {
                this.pager.currentPage = 1;
                this.loadData();
            },
            deep: true
        }
    },
    methods: {
        ...mapMutations(["openTab"]),
        generateQuestion() {
            this.$ajaxGet("/question/checkQuestion/" + this.form.examId, (data) => {
                this.addGenerateQuestion = {...this.attr.exam};
                this.showGenerateQuestion = true;
            })
        },
        addByPlatform() {//总部提供的考试  导入考试的题目
            this.$ajaxGet("/question/checkQuestion/" + this.form.examId, (data) => {
                this.addExamItem = {...this.attr.exam};
                this.showChooseExam = true;
            })
        },
        emptyQuestion() {
            this.$ajaxGet("/question/delByExamId/" + this.form.examId, (data) => {
                this.$showSuccess("操作成功");
                this.loadData();
            })
        },
        editScore() {
            this.openTab({
                funcKey: "school_exam_batch_edit_score",
                title: "编辑分数",
                allowDuplicate: true,
                attr: {
                    examId: this.form.examId
                }
            });
        },
        add() {
            this.editItem = {...this.attr.exam};
            this.showAdd = true;
        },
        addChoose() {
            this.chooseItem = {...this.attr.exam};
            this.showChoose = true;
        },
        edit(item) {
            this.editItem = {...item};
            this.showEdit = true;
        },
        up(item, index) {
            if (index == 0) {
                return;
            } else {
                let prevItem = this.tableData[index - 1];
                this.$ajaxGet(`/question/updateCreateTime/${item.id}-${item.createTime}-${prevItem.rank}`, data => {
                    this.loadData();
                })
            }
        },
        editCustom(item) {
            this.currentCustom = {...item};
            this.showCustom = true;
        },
        down(item, index) {
            if (index == this.tableData.length - 1) {
                return;
            } else {
                let afterItem = this.tableData[index + 1];
                this.$ajaxGet(`/question/updateCreateTime/${item.id}-${item.rank}-${afterItem.rank}`, data => {
                    this.loadData();
                })
            }
        },
        loadLessonTypes() {
            this.$ajaxGet("/question/lessonType", (data) => {
                this.lessonTypes.push(...data.result);
            })
        },
        deleteQuestion(item) {
            this.$ajaxGet("/question/delQuestionById/" + item.id, (data) => {
                this.loadData();
            })
        },
        loadData() {
            this.$ajaxPost("/question/listQuestion", {
                form: this.form,
                pager: {...this.pager, dataTotal: 0}
            }, (data) => {
                //分页不能带offset，否则会影响后台计算最新offset
                let {offset, ...pager} = data.pager;
                this.pager = pager;
                this.showAdd = false;
                this.showChoose = false;
                this.showChooseExam = false;
                this.showGenerateQuestion = false;
                this.tableData = data.result;
                this.showEdit = false;
                this.loadTotalScore();
            })
        },
        pageChange(page) {
            this.pager.currentPage = page;
            this.loadData();
        },
        loadTotalScore() {
            this.$ajaxPost("/question/getTotalScore/" + this.form.examId, {}, (data) => {
                if (data && data.success) {
                    this.planTotalScore = data.result.planTotalScore;
                    this.questionBankTotalScore = data.result.questionBankTotalScore;
                }
            })
        },
    },
    created() {
        this.loadData();
        this.loadLessonTypes();
        this.loadTotalScore();
    }
}
</script>
